module.exports = __webpack_public_path__ + "static/media/toystory2.055e1f01.gif";